import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Box from '@material-ui/core/Box';
import PropTypes from 'prop-types';

import { useTranslation } from 'react-i18next';

// style
import { styles, LegendTableCell } from './style';
import './styles.css';

function Blank() {
  return (
    <>
      <Box m={0} p={0} display="block" style={{ background: '#ccc', height: '16px' }} />
      {' '}
    </>
  );
}

function createData(color, Salinity, pH, Do, Tur, comment) {
  return {
    color, Salinity, pH, Do, Tur, comment,
  };
}

const useStyles = makeStyles(styles);

export default function WaterQualityLegend(props) {
  const { t } = useTranslation();
  const classes = useStyles();
  const { keyLegend } = props;

  const rows = [
    createData('#B02418', '> 2', <Blank />, <Blank />, <Blank />, <Box pl={1}>{t('เกินเกณฑ์มาตรฐานน้ำใช้เพื่อการเกษตร')}</Box>),
    createData('#EA3423', '> 0.5', '<5 หรือ >9', '< 2', '> 1,000', <Box pl={1}>{t('เกินเกณฑ์คุณภาพน้ำเพื่อการผลิตน้ำประปา')}</Box>),
    createData('#F7C142', '> 0.25', <Blank />, <Blank />, '100 - 1,000', <Box pl={1}>{t('เกณฑ์เฝ้าระวังคุณภาพน้ำเพื่อการผลิตน้ำประปา')}</Box>),
    createData('#4EAC5B', '< 0.25', '5-9', '< 2', '≤ 100', <Box pl={1}>{t('เกณฑ์ปกติ')}</Box>),
  ];

  const rowsphs = [
    createData('#EA3423', '< 0.5', '<5, >9', '< 2', '> 1,000', <Box pl={1}>{t('เกินเกณฑ์คุณภาพน้ำเพื่อการผลิตน้ำประปา')}</Box>),
    createData('#4EAC5B', '< 0.25', '5-9', '< 2', '≤ 100', <Box pl={1}>{t('เกณฑ์ปกติ')}</Box>),
  ];

  const rowsTurs = [
    createData('#EA3423', '< 0.5', '<5 หรือ >9', '< 2', '> 1,000', <Box pl={1}>{t('เกินเกณฑ์คุณภาพน้ำเพื่อการผลิตน้ำประปา')}</Box>),
    createData('#F7C142', '< 0.25', <Blank />, <Blank />, '100 - 1,000', <Box pl={1}>{t('เกณฑ์เฝ้าระวังคุณภาพน้ำเพื่อการผลิตน้ำประปา')}</Box>),
    createData('#4EAC5B', '< 0.25', '5-9', '< 2', '≤ 100', <Box pl={1}>{t('เกณฑ์ปกติ')}</Box>),
  ];

  const rowsTds = [
    createData('#EA3423', '< 0.5', '<5 หรือ >9', '< 2', '> 2,001', <Box pl={1}>{t('เกินเกณฑ์คุณภาพน้ำเพื่อการผลิตน้ำประปา')}</Box>),
    createData('#F7C142', '< 0.25', <Blank />, <Blank />, '1,001 - 2,000', <Box pl={1}>{t('เกณฑ์เฝ้าระวังคุณภาพน้ำเพื่อการผลิตน้ำประปา')}</Box>),
    createData('#4EAC5B', '< 0.25', '5-9', '< 2', '< 1,000', <Box pl={1}>{t('เกณฑ์ปกติ')}</Box>),
  ];

  const rowsDo = [
    createData('#EA3423', '< 2', '< 2', '< 2', '< 2', <Box pl={1}>{t('เกินเกณฑ์คุณภาพน้ำเพื่อการผลิตน้ำประปา')}</Box>),
    createData('#4EAC5B', '> 2 ', '> 2', '> 2', '> 2', <Box pl={1}>{t('เกณฑ์ปกติ')}</Box>),
  ];

  // function LegendAll() {
  //   return (
  //     <React.Fragment key="key">
  //       <TableContainer>
  //         <Table className={classes.tableLegend} aria-label="a dense table">
  //           <TableHead>
  //             <TableRow>
  //               <LegendTableCell align="center">สี</LegendTableCell>
  //               <LegendTableCell align="center">
  //                 Salinity
  //                 <br />
  //                 (g/L)
  //               </LegendTableCell>
  //               <LegendTableCell align="center">pH</LegendTableCell>
  //               <LegendTableCell align="center">Do(mg/L)</LegendTableCell>
  //               <LegendTableCell align="center">Tur(NTU)</LegendTableCell>
  //               <LegendTableCell align="left">คำอธิบาย</LegendTableCell>
  //             </TableRow>
  //           </TableHead>
  //           <TableBody>
  //             {rows.map((row, i) => (
  //               <TableRow key={i}>
  //                 <LegendTableCell component="th" scope="row" style={{ background: `${row.color}` }} />
  //                 <LegendTableCell align="center">{row.Salinity}</LegendTableCell>
  //                 <LegendTableCell align="center">{row.pH}</LegendTableCell>
  //                 <LegendTableCell align="center">{row.Do}</LegendTableCell>
  //                 <LegendTableCell align="center">{row.Tur}</LegendTableCell>
  //                 <LegendTableCell align="left">{row.comment}</LegendTableCell>
  //               </TableRow>
  //             ))}
  //           </TableBody>
  //         </Table>
  //       </TableContainer>
  //     </React.Fragment>
  //   );
  // }

  function LegendSalinity() {
    return (
      <TableContainer>
        <Table className={classes.tableLegend} aria-label="a dense table">
          <TableHead>
            <TableRow>
              <LegendTableCell align="center" style={{ fontSize: '12px' }}>{t('สี')}</LegendTableCell>
              <LegendTableCell align="center" style={{ fontSize: '12px' }}>
                Salinity
                <br />
                (g/L)
              </LegendTableCell>
              <LegendTableCell align="left" style={{ fontSize: '12px' }}>{t('คำอธิบาย')}</LegendTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row, i) => (
              <TableRow key={i}>
                <LegendTableCell component="th" scope="row" style={{ background: `${row.color}` }} />
                <LegendTableCell align="center" style={{ fontSize: '12px' }}>{row.Salinity}</LegendTableCell>
                <LegendTableCell align="left" style={{ fontSize: '12px' }}>{row.comment}</LegendTableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    );
  }

  function LegendpH() {
    return (
      <TableContainer>
        <Table className={classes.tableLegend} aria-label="a dense table">
          <TableHead>
            <TableRow>
              <LegendTableCell align="center" style={{ fontSize: '12px' }}>{t('สี')}</LegendTableCell>
              <LegendTableCell align="center" style={{ fontSize: '12px' }}>pH</LegendTableCell>
              <LegendTableCell align="left" style={{ fontSize: '12px' }}>{t('คำอธิบาย')}</LegendTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rowsphs.map((row, i) => (
              <TableRow key={i}>
                <LegendTableCell component="th" scope="row" style={{ background: `${row.color}` }} />
                <LegendTableCell align="center" style={{ fontSize: '12px' }}>{row.pH}</LegendTableCell>
                <LegendTableCell align="left" style={{ fontSize: '12px' }}>{row.comment}</LegendTableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    );
  }

  function LegendDo() {
    return (
      <TableContainer>
        <Table className={classes.tableLegend} aria-label="a dense table">
          <TableHead>
            <TableRow>
              <LegendTableCell align="center" style={{ fontSize: '12px' }}>{t('สี')}</LegendTableCell>
              <LegendTableCell align="center" style={{ fontSize: '12px' }}>Do(mg/L)</LegendTableCell>
              <LegendTableCell align="left" style={{ fontSize: '12px' }}>{t('คำอธิบาย')}</LegendTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rowsDo.map((row, i) => (
              <TableRow key={i}>
                <LegendTableCell component="th" scope="row" style={{ background: `${row.color}` }} />
                <LegendTableCell align="center" style={{ fontSize: '12px' }}>{row.Do}</LegendTableCell>
                <LegendTableCell align="left" style={{ fontSize: '12px' }}>{row.comment}</LegendTableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    );
  }

  function LegendTur() {
    return (
      <TableContainer>
        <Table className={classes.tableLegend} aria-label="a dense table">
          <TableHead>
            <TableRow>
              <LegendTableCell align="center" style={{ fontSize: '12px' }}>{t('สี')}</LegendTableCell>
              <LegendTableCell align="center" style={{ fontSize: '12px' }}>Turbidity (NTU)</LegendTableCell>
              <LegendTableCell align="left" style={{ fontSize: '12px' }}>{t('คำอธิบาย')}</LegendTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rowsTurs.map((row, i) => (
              <TableRow key={i}>
                <LegendTableCell component="th" scope="row" style={{ background: `${row.color}` }} />
                <LegendTableCell align="center" style={{ fontSize: '12px' }}>{row.Tur}</LegendTableCell>
                <LegendTableCell align="left" style={{ fontSize: '12px' }}>{row.comment}</LegendTableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    );
  }

  function LegendTds() {
    return (
      <TableContainer>
        <Table className={classes.tableLegend} aria-label="a dense table">
          <TableHead>
            <TableRow>
              <LegendTableCell align="center" style={{ fontSize: '12px' }}>{t('สี')}</LegendTableCell>
              <LegendTableCell align="center" style={{ fontSize: '12px' }}>TDS</LegendTableCell>
              <LegendTableCell align="left" style={{ fontSize: '12px' }}>{t('คำอธิบาย')}</LegendTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rowsTds.map((row, i) => (
              <TableRow key={i}>
                <LegendTableCell
                  component="th"
                  scope="row"
                  style={{ background: `${row.color}` }}
                />
                <LegendTableCell align="center" style={{ fontSize: '12px' }}>{row.Tur}</LegendTableCell>
                <LegendTableCell align="left" style={{ fontSize: '12px' }}>{row.comment}</LegendTableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    );
  }

  function renderLegend() {
    switch (keyLegend) {
      case 'กรด-ด่าง':
        return LegendpH();
      case 'ความเค็ม':
        return LegendSalinity();
      case 'ความขุ่น':
        return LegendTur();
      case 'สารละลาย':
        return LegendTds();
      case 'ออกซิเจน':
        return LegendDo();
      default:
        return LegendpH();
    }
  }

  return (
    <>
      {renderLegend()}
    </>
  );
}

WaterQualityLegend.propTypes = {
  keyLegend: PropTypes.string.isRequired,
};
